<template>
  <el-dialog class="customDialog layerAttribute" :style="{'margin-top':marginTop}" title="属性管理" :close-on-press-escape = 'false' :visible.sync="isShow" :modal="true" :close-on-click-modal="false" @close="onClose">
    <!-- <span slot="footer">
      <el-button type="default" @click="onClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
    </span> -->
    <el-table ref="attributeTable" stripe :data="attributeData" height="2.9rem">
      <template slot="empty">
        <Empty></Empty>
      </template>
      <el-table-column
        v-for="(item ,index) in attrubuteColumns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :formatter="item.formatter"
        :align="item.align"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" width="80" align="center" v-if="!shared">
        <template slot-scope="scope">
<!--          <div class="action-btn">-->
<!--            <el-button type="text" :disabled="!!tableId&&scope.row.type!=='NUMBER'" @click="editAttribute(scope.row)">编辑</el-button>-->
<!--            &lt;!&ndash; <span @click="editAttribute(scope.row)">编辑</span> &ndash;&gt;-->
<!--            <span class="line"></span>-->
<!--            <el-button type="text" @click="removeAttribute(scope.$index)">删除</el-button>-->
<!--            &lt;!&ndash; <span v-show="!tableId" @click="removeAttribute(scope.$index)">删除</span> &ndash;&gt;-->
<!--          </div>-->
          <div class="action-btn">
            <el-tooltip content="编辑" placement="top" effect="light" :open-delay="1000" :enterable="false">
              <Icon name="icon-edit" @click="editAttribute(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER||(!!tableId && scope.row.type!=='NUMBER')"></Icon>
            </el-tooltip>
            <el-tooltip content="删除" placement="top" effect="light" :open-delay="1000" :enterable="false">
              <Icon name="icon-ashbin" @click="removeAttribute(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER||(!!tableId)"></Icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="70" align="center">
        <template slot-scope="scope">
          <div class="action-btn">
            <Icon type="small" name="icon-arrow-up-circle" @click="onSortAttribute(true,scope.$index)" :disabled="scope.$index===0||permissionLevel <= PermissionLevel.LOOKER"></Icon>
            <Icon type="small" name="icon-direction-down-circle" @click="onSortAttribute(false,scope.$index)" :disabled="scope.$index===attributeData.length-1||permissionLevel <= PermissionLevel.LOOKER"></Icon>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-button v-show="!tableId && !isShowEdit" :disabled="permissionLevel <= PermissionLevel.LOOKER" class="add-attribute-btn" type="primary" @click="addAttribute" v-if="!shared">新增</el-button>
    <div v-show="isShowEdit" class="addribute-edit-form">
      <el-form :model="formInline" :rules="rules" ref="form" label-width="140px" class="demo-form-inline">
        <el-form-item label="属性名称：" prop="name">
          <el-col :span="20">
            <el-input class="form-short" v-model.trim="formInline.name" :disabled="!!tableId" placeholder="请输入20字以内" :maxlength="20" show-word-limit></el-input>
          </el-col>
          <el-col :span="4" class="item-col" v-show="false">
            <el-checkbox v-model="formInline.required" :disabled="!!tableId">必填</el-checkbox>
          </el-col>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
          <el-col :span="20">
            <el-select class="form-short" v-model="formInline.type" filterable  placeholder="请选择" :disabled="!!formInline.id">
              <el-option v-for="item in MarkerAttributeType2" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" class="item-col">
            <el-checkbox v-model="formInline.multiSelect" v-if="formInline.type==='SELECT'">允许多选</el-checkbox>
          </el-col>
        </el-form-item>
        <el-form-item label="单位：" prop="unit" v-if="formInline.type==='NUMBER'">
          <el-col :span="20">
            <el-input class="form-short" v-model.trim="formInline.unit" placeholder="请输入3字以内" :maxlength="3" show-word-limit></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="选项列表：" prop="newOpName" v-if="formInline.type==='SELECT'">
          <el-col :span="20">
            <el-input class="form-short" v-model.trim="formInline.newOpName" required error="请输入选项列表"  placeholder="请输入20字以内" :maxlength="20" show-word-limit></el-input>
          </el-col>
          <el-col :span="4" class="item-col">
            <el-button type="default" icon="el-icon-plus" @click="addOptions" style="border-radius: 6px;"></el-button>
          </el-col>
        </el-form-item>
        <div class="attribute-options-list" v-if="formInline.type==='SELECT'">
          <div v-for="(opitem, index) in formInline.options" :key="index" class="option-attribute">
            <el-input class="option-item" v-model="opitem.value"  placeholder="请输入20字以内" :maxlength="20" show-word-limit></el-input>
            <div class="option-icon" >
              <Icon type="big" name="icon-arrow-up-circle" @click="onSortOption(true, index)" :disabled="index===0"></Icon>
              <Icon type="big" name="icon-direction-down-circle" @click="onSortOption(false, index)" :disabled="index===formInline.options.length-1"></Icon>
              <Icon type="big" name="icon-error" @click="onRemoveOption(index)"></Icon>
            </div>
          </div>
        </div>
      </el-form>
      <div class="footer">
        <el-button type="default" @click="onCancelEdit">取消</el-button>
        <el-button type="primary" :loading="loading" @click="onSubmit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { addLayerProperty, updateLayerProperty, getLayer } from '@/api/marker'
import { PermissionLevel, MarkerAttributeType2 } from '@/configs/constants'

export default {
  name: 'LayerAttribute',
  computed: {
    ...mapGetters(['isTemplate', 'permissionLevel']),
    marginTop () {
      if (this.isShowEdit) {
        if (this.formInline.type === 'SELECT') {
          return '-70px'
        }
        return '0px'
      }
      return '100px'
    }
  },
  inject: ['shared'],
  data () {
    return {
      isShow: false,
      formInline: {
        type: undefined,
        name: '',
        unit: '',
        newOpName: undefined,
        required: false,
        multiSelect: false,
        options: [
          // { id: 'selectitem0', name: undefined, sort: 0 }
        ]
      },
      attrubuteColumns: [
        {
          prop: 'name',
          label: '属性名称',
          align: 'left',
          formatter: (row, column) => {
            if (row.required) {
              return <div><span style="color:#FF0000; margin-right:8px">*</span><span>{row.name}</span></div>
            } else {
              return row.name
            }
            // return row.name
          }
          // width: '200'
        },
        {
          prop: 'type',
          label: '类型',
          align: 'left',
          formatter: (row, column) => {
            for (let i = 0; i < this.MarkerAttributeType2.length; i++) {
              if (this.MarkerAttributeType2[i].value === row.type) {
                return this.MarkerAttributeType2[i].name
              }
            }
            return ''
          }
          // width: '200'
        },
        {
          prop: 'unit',
          label: '单位',
          align: 'left'
          // width: '200'
        }
      ],
      rules: {
        name: [
          { required: true, message: '请输入属性名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择属性类型', trigger: 'blur' }
        ],
        unit: [
          { required: true, message: '请输入属性单位', trigger: 'blur' },
          { min: 1, max: 3, message: '请输入3字以内', trigger: 'blur' }
        ],
        newOpName: [
          { required: true, message: '请输入选项列表', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ]
      },
      layerId: undefined,
      tableId: undefined,
      // 自定义属性数据
      attributeData: [],
      MarkerAttributeType2,
      // 是否显示编辑
      isShowEdit: false,
      loading: false,
      PermissionLevel
    }
  },
  mounted () {},
  methods: {
    open (id) {
      this.isShow = true
      this.layerId = id
      // this.getLayerAttributes()
      this.getLayer()
    },
    // 获取图层详情
    async getLayer () {
      const params = {
        id: this.layerId
      }
      const res = await getLayer(params)
      if (res.code === 200) {
        this.attributeData = res.data.properties ? res.data.properties.filter(item => item.display !== false) : []
        this.attributeData.sort((a, b) => {
          return a.sort - b.sort
        })
        this.tableId = res.data.tableId
      }
    },
    // 获取图层属性
    // getLayerAttributes () {
    //   getLayerProperty({
    //     layerId: this.layerId
    //   }).then(res => {
    //     this.attributeData = res.data ? res.data : []
    //     this.attributeData.sort((a, b) => {
    //       return a.sort - b.sort
    //     })
    //   })
    // },
    // 修改图层属性
    async updateLayerAttribute (data) {
      console.log(this.attributeData, data)
      if (data) {
        this.attributeData = this.attributeData.filter(item => {
          return item.id !== data.id
        })
        this.attributeData.push(data)
      }
      if (this.loading) {
        return
      }
      try {
        this.loading = true
        const res = await updateLayerProperty({
          layerId: this.layerId,
          properties: this.attributeData
        })
        if (res.code === 200) {
          this.getLayer()
          this.$emit('refresh')
          this.$Message('success', res.msg || '操作成功')
        }
      } finally {
        this.loading = false
      }
    },
    // 添加图层属性
    addLayerAttribute (data) {
      // this.attributeData.push(data)
      const arr = JSON.parse(JSON.stringify(this.attributeData))
      arr.push(data)
      addLayerProperty({
        layerId: this.layerId,
        properties: arr
      }).then(res => {
        this.loading = false
        this.getLayer()
        this.$Message('success', res.msg || '操作成功')
        this.$emit('refresh')
      }).catch(res => {
        this.loading = false
      })
    },
    clear () {
      // this.$refs.form.resetFields()
      this.isShowEdit = false
      this.formInline = this.$options.data().formInline
      this.$refs.form.clearValidate()
    },
    onClose () {
      this.clear()
      this.isShow = false
    },
    // 添加下拉属性
    addOptions () {
      this.$refs.form.validateField(['newOpName'], (error) => {
        if (!error) {
          const optionLen = this.formInline.options.length
          this.formInline.options.push({
            key: 'selectitem' + optionLen,
            value: this.formInline.newOpName,
            sort: optionLen
          })
          this.formInline.newOpName = undefined
        } else {
          // this.$Message('error', '提交数据格式错误')
        }
      })
    },
    // 编辑属性
    editAttribute (data) {
      this.clear()
      this.formInline = JSON.parse(JSON.stringify(data))
      // this.formInline = {
      //   id: data.id,
      //   multiSelect: data.multiSelect,
      //   type: data.type,
      //   name: data.name,
      //   unit: data.unit,
      //   required: data.required,
      //   newOpName: undefined,
      //   options: []
      // }
      // if (data.type === 'SELECT' && data.options !== undefined) {
      //   for (let i = 0; i < data.options.length; i++) {
      //     const item = this.formInline.options[i]
      //     this.formInline.options.push({
      //       key: item.key,
      //       value: item.value,
      //       sort: item.sort
      //     })
      //   }
      // }
      this.isShowEdit = true
    },
    // 删除属性
    removeAttribute (row) {
      const index = this.attributeData.findIndex(item => {
        return item.id === row.id
      })
      this.$Delete({
        message: '您确定删除该数据吗，删除后不可恢复？',
        confirm: () => {
          this.attributeData.splice(index, 1)
          this.updateLayerAttribute()
        },
        cancel: () => {
        }
      })
    },
    // 添加属性
    addAttribute () {
      this.clear()
      this.formInline.sort = this.attributeData.length + 1
      this.isShowEdit = true
    },
    // 取消标记
    onCancelEdit () {
      this.clear()
      this.isShowEdit = false
    },
    // 属性排序
    onSortAttribute (isUp, index) {
      if (isUp) {
        this.attributeData[index].sort--
        this.attributeData[index - 1].sort++
      } else {
        this.attributeData[index].sort++
        this.attributeData[index + 1].sort--
      }
      this.attributeData.sort((a, b) => {
        return a.sort - b.sort
      })
      this.updateLayerAttribute()
    },
    // 排序
    onSortOption (isUp, index) {
      if (isUp) {
        this.formInline.options[index].sort--
        this.formInline.options[index - 1].sort++
      } else {
        this.formInline.options[index].sort++
        this.formInline.options[index + 1].sort--
      }
      this.formInline.options.sort((a, b) => {
        return a.sort - b.sort
      })
    },
    // 删除下拉属性
    onRemoveOption (index) {
      this.formInline.options.splice(index, 1)
    },
    onSubmit () {
      console.log(this.formInline)
      if (this.formInline.newOpName) {
        const optionLen = this.formInline.options.length
        this.formInline.options.push({
          key: 'selectitem' + optionLen,
          value: this.formInline.newOpName,
          sort: optionLen
        })
        this.formInline.newOpName = undefined
      }
      let isValidate = true
      this.$refs.form.validateField(['name', 'type', 'unit'], (error) => {
        if (error) {
          isValidate = false
        } else {
          // this.$Message('error', '提交数据格式错误')
        }
      })
      if (isValidate) {
        this.loading = true
        this.isShowEdit = false
        if (!this.formInline.id) {
          this.addLayerAttribute(this.formInline)
        } else {
          this.updateLayerAttribute(this.formInline)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.layerAttribute {
  // .el-dialog{
  //   margin: 50px auto
  // }
  .el-dialog{
    width: 890px;
  }
  .el-table .el-table__body-wrapper tr > td:first-child > .cell {
    display: block !important;
    >div{
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .add-attribute-btn{
    margin-top: $space-md;
    width: 80px;
  }
  .addribute-edit-form{
    margin-top: 12px;
    background: #303132;
    border-radius: 6px;
    width: 849px;
    max-height: 393px;
    overflow-y: auto;
    .el-form {
      margin-left: 139px;
      width: 480px;
      .el-form-item {
        &:first-child {
          margin-top: 10px;
        }
      }
    }
  }
  .form-short {
    width: 260px;
    margin-right: 20px;
  }
  .item-col{
    margin-left: -13px;
    .el-button{
      // width: 32px;
      // height: 32px;
      padding: 0 8px !important;
      margin-left: -23px;
    }
  }
  .attribute-options-list{
    // margin-top: -21px;
    margin-left: 136px;
    >.option-attribute:first-child {
      margin-top: -5px;
    }
    .option-attribute{
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      padding-left: 6px;
      width: 365px;
    }
    .option-item{
      width: 260px;
      height: 32px;
      // background: rgba(255, 255, 255, 0);
      // border: 1px solid #454647;
      // border-radius: 6px;
      .option-icon{
        display: flex;
        width: 100px;
        transform: translateY(-5px);
      }
      .el-input__inner{
        background: rgba(255, 255, 255, 0);
        border: 1px solid #454647;
        &:focus{
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(0, 164, 240, 1);
        }
      }
    }
    // .custom-icon{
    //   display: inline-block;
    //   top: 5px;
    //   position: relative;
    // }
  }
  .footer{
    .el-button{
      width: 80px;
    }
    margin: 20px auto;
  }
}
</style>
